<template>
  <div v-wechat-title="titleTop" class="allBack">
    <TopBar :pagetitle="title" :back-url="backurl" @leftClick="test" />
    <div class="topBackRect">
      <div class="topRectBack">
        <div class="topRect">
          <div class="cloud" style="left:1em;top:1em">
            <img src="/grouptest/score/could.png">
          </div>
          <div class="cloud" style="right:1em;bottom:2.2em">
            <img src="/grouptest/score/could.png">
          </div>
          <van-row class="topBar">
            <van-col span="9" />
            <van-col span="6" class="center" style="line-height:2.6em">我的金币</van-col>
            <van-col span="9" class="rigth">
              <img src="/grouptest/score/button_about.png" @click="onAbout">
            </van-col>
          </van-row>
          <div class="myMoney">
            <span>￥</span>{{ ShowMoney(totalPrice) }}
          </div>
          <div class="progress">
            <img src="/grouptest/score/progressbar_back.png">
            <div class="progressTop" :style="'width:'+progress+'%'">
              <img src="/grouptest/score/progressbar_value1.png">
            </div>
          </div>
        </div>
      </div>
      <div v-if="data" class="giftList">
        <table width="100%">
          <tr>
            <td v-for="(item,index) in data.activity.items" :key="index" width="20%">
              <div class="giftIcon">
                <img :src="'/grouptest/score/level'+index+'.png'">
                <div class="icon">
                  <img :src="item.icon">
                </div>
                <div class="topBack" @click="onViewItem(item.commodityId)">
                  <img :src="'/grouptest/score/level'+index+'.png'">
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td v-for="(item,index) in data.activity.items" :key="index" class="giftName" @click="onViewItem(item.commodityId)">
              {{ item.name }}
            </td>
          </tr>
          <tr>
            <td v-for="(item,index) in data.activity.items" :key="index" class="giftPrice">
              <span>￥</span>{{ ShowFloat(item.priceShow,0) }}
            </td>
          </tr>
          <tr>
            <td v-for="(item,index) in data.activity.items" :key="index" class="giftButton">
              <img v-if="index > data.itemHaveList.length && data.level>item.level" :src="'/grouptest/score/button_2.png'" @click="onGetGift(3,item)">
              <img v-if="index > data.itemHaveList.length && data.level<=item.level" :src="'/grouptest/score/button_2.png'" @click="onGetGift(2,item)">
              <img v-if="index <= data.itemHaveList.length && getHaveGift(item)" :src="'/grouptest/score/button_0.png'" @click="onGetGift(0,item)">
              <img v-if="index <= data.itemHaveList.length && !getHaveGift(item)" :src="'/grouptest/score/button_1.png'" @click="onGetGift(1,item)">
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="baseRect">
      <div class="titleRect">
        <span class="titleBody">我的潜伴</span>
      </div>
      <div v-if="data" class="listRect">
        <van-row v-for="(item,index) in data.helpers" :key="index" class="lineRect">
          <van-col span="4">
            <van-image
              radius="0.2em"
              width="2em"
              height="2em"
              fit="cover"
              :src="item.icon?item.icon:'/img/defaultIcon.jpg'"
            />
          </van-col>
          <van-col span="14">{{ item.nickName?item.nickName:titleTop }}</van-col>
          <van-col span="6" class="price rigth">+{{ ShowMoney(item.price) }}</van-col>
        </van-row>
        <van-row v-if="data.totalHelper>data.helpers.length" class="lineRect">
          <van-col span="24" class="price center">
            等{{ data.totalHelper-data.helpers.length }}名潜伴</van-col>
        </van-row>
      </div>
    </div>
    <div class="emptyRect" />
    <div class="downButtonRect">
      <van-row gutter="20">
        <van-col span="12">
          <imageButton
            title="获取红包"
            image="/grouptest/score/buttonOrangeBack.png"
            image-select="/grouptest/score/buttonOrangeBack.png"
            :width="100"
            font-color="#000"
            font-select-color="#fff"
            @click="onShare"
          />
        </van-col>
        <van-col span="12">
          <imageButton
            title="我的海报"
            image="/grouptest/score/buttonBlueBack.png"
            image-select="/grouptest/score/buttonBlueBack.png"
            :width="100"
            font-color="#000"
            font-select-color="#fff"
            @click="onPoster"
          />
        </van-col>
      </van-row>
    </div>
    <van-popup v-model="showPoster" class="posterPage">
      <div class="backButton" @click="showPoster=false"><i class="iconfont iconclosex" /></div>
      <img :src="posterUrl" class="posterImg">
      <imageButton
        title="立即分享"
        image="/grouptest/score/buttonBlueBack.png"
        image-select="/grouptest/score/buttonBlueBack.png"
        :width="40"
        font-color="#000"
        font-select-color="#fff"
        @click="onShare"
      />
      <div class="shareAbout">分享专属海报，每邀请一位潜水员打开红包，则可为自己打开一枚新红包!</div>
    </van-popup>
    <wxShare v-model="showShare" share-title="点击右上角分享，每邀请一位潜水员打开红包，则可为自己打开一枚新红包" :title="shareTitle" :desc="shareAbout" :timeline="shareTimeline" :url="shareUrl" :img="shareIcon" @onFinish="shareUrl=undefined" />
    <bindDiver v-model="showBindDiver" page-style="activity61" :notice-url="noticeUrl" @finish="onBindFinish" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Image, Dialog, Popup, Toast } from 'vant'
import TopBar from '@/components/TopBar'
import { GetServiceUrl, GetSelfUrl } from '@/utils/request'
import imageButton from '@/components/imageButton'
import { getUserBase, UrlBase64, MyNotify, ShowFloat, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { getUrlKey, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import { getToken } from '@/utils/auth'
import wxShare from '@/components/wxShare'
import bindDiver from '@/components/bindDiver'
import { checkActivity } from '@/utils/baseData'
export default {
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
    [Dialog.name]: Dialog,
    [Popup.name]: Popup,
    TopBar,
    imageButton,
    wxShare,
    bindDiver
  },
  data() {
    return {
      titleTop: '',
      title: '20200601',
      backurl: '/group/scoreWelcome',
      system: undefined,
      data: undefined,
      progress: 0,
      userId: undefined,
      totalPrice: 0,
      showPoster: false,
      showBindDiver: false,
      posterUrl: undefined,
      showShare: false,
      shareTitle: '',
      shareAbout: '',
      shareTimeline: '',
      shareUrl: '',
      shareIcon: '',
      noticeUrl: undefined
    }
  },

  created() {
    this.system = getUrlKey('system')
    this.userId = getUrlKey('u')
    this.init(() => {
      this.titleTop = GetSysTitle()
      this.showFollow = true
      this.initShare()
    })
  },
  activated() {
  },
  methods: {
    ShowFloat,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    init(callback) {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner'
      })
      request({
        url: '/Activity/getPieceMoneySelf',
        method: 'post',
        data: {
          key: 'cool20200601',
          userId: this.userId }
      }).then(response => {
        Toast.clear()
        if (!response.success) {
          return
        }
        this.data = response.data
        this.title = this.data.activity.shortTitle
        this.progress = this.data.percentage
        this.totalPrice = this.data.totalPrice
        if (callback) {
          callback()
        }
      })
    },
    onViewItem(id) {
      this.$router.push('/store/item/' + id)
    },
    getHaveGift(item) {
      var fintObj = this.data.itemHaveList.filter(m => m === item.specificationId || m === item.commodityId)
      return fintObj.length > 0
    },
    onGetGift(typeId, item) {
      if (checkActivity(this.data.activity, true)) {
        // console.log('onGetGift', typeId)
        // console.log('onGetGift', item)
        // console.log('typeId', typeId)
        // console.log('this.data.level ', this.data.level)
        // console.log(' this.data.itemHaveList.length ', this.data.itemHaveList.length)
        if (typeId === 1 && this.data.level <= item.level) {
          typeId = 2
        } else if (typeId === 2 && this.data.level > this.data.itemHaveList.length) {
          typeId = 3
        }

        if (typeId === 2) {
          Dialog.confirm({
            title: '金币不足',
            message: '邀请其他潜水员为您解锁更多红包!',
            confirmButtonText: '立刻邀请'

          })
            .then(() => {
              this.onPoster()
            })
            .catch(() => {
              MyNotify('info', '邀请潜伴即可获得免费充值,兑换想要的奖品!')
            })
        } else if (typeId === 3) {
          Dialog.alert({
            title: '未领取上一级奖品',
            message: '未领取上一级奖品，必须先领取上一级奖品!',
            confirmButtonText: '我知道了'

          })
        } else if (typeId === 0) {
          Dialog.confirm({
            title: '已经兑换成功',
            message: '已经兑换奖品，前往购物车下单领奖!\r\n可以多个奖品一起下单领奖哦!',
            confirmButtonText: '前往购物车下单'

          })
            .then(() => {
              this.$router.push('/store/car')
            })
            .catch(() => {
              MyNotify('info', '可以获得多个奖品后一次性下单领取!')
            })
        } else {
          this.getGift(item)
        }
      }
    },
    getGift(item) {
      request({
        url: '/Activity/getPieceMoneyGiftCoupon',
        method: 'post',
        data: {
          key: 'cool20200601',
          level: item.level }
      }).then(response => {
        if (!response.success) {
          return
        }
        MyNotify('success', '兑换成功!')
        this.onGetGift(0, item)
        this.init()
      })
    },
    onAbout() {
      if (checkActivity(this.data.activity, true)) {
        this.$router.push('/group/scoreWelcome')
      }
    },
    onBindFinish() {
      this.init()
    },
    onBindDiver() {
      Dialog.alert({
        title: '潜水员专属活动',
        message: '该活动是潜水员专属活动，请先确定潜水员身份后方可参加!',
        confirmButtonText: '绑定潜水员'
      })
        .then(() => {
          this.noticeUrl = GetSelfUrl() + 'group/score?system=' + this.system
          this.showBindDiver = true
        })
    },
    onShare() {
      if (checkActivity(this.data.activity, true)) {
        if (!this.data.isDiver) {
          this.onBindDiver()
          return
        }
        getUserBase(userInfo => {
          this.initShare(() => {
            this.showShare = true
          })
        })
      }
    },
    initShare(callback) {
      getUserBase(userInfo => {
        console.log('用户数据', userInfo)
        this.shareTitle = this.data.activity.value.shareTitle.replace('[name]', userInfo ? userInfo.nickName : '')
        this.shareAbout = this.data.activity.value.shareAbout.replace('[name]', userInfo ? userInfo.nickName : '')
        this.shareTimeline = this.data.activity.value.shareTitle.replace('[name]', userInfo ? userInfo.nickName : '')
        this.shareIcon = this.data.activity.value.shareIcon
        this.shareUrl = GetSelfUrl() + 'group/score?u=' + this.data.userId + '&system=' + this.system
        if (callback) {
          callback()
        }
      })
    },
    onPoster() {
      if (checkActivity(this.data.activity, true)) {
        if (!this.data.isDiver) {
          this.onBindDiver()
          return
        }
        this.showPoster = true
        this.posterUrl = GetServiceUrl() + 'Activity/getPoeceMoneyPoster?token=' + UrlBase64(getToken())
      }
    },
    test() {
      return true
    }
  }
}
</script>
<style scoped>
.allBack{
  min-height: 100vh;
  background-color: #4140FE;
}
.topBackRect{
  background-color: #527EFE;
  padding:1em 0;
}
.topRectBack{
  background: #000;
  margin:  0 1em;
  background: linear-gradient(135deg, transparent 0.3em, #000 0) top left,
  linear-gradient(-135deg, transparent 0.3em, #000 0) top right,
  linear-gradient(-45deg, transparent 0.3em, #000 0) bottom right,
  linear-gradient(45deg, transparent 0.3em, #000 0) bottom left;
  background-size: 51% 51%;
  background-repeat: no-repeat;
  height: 8em;
  position: relative;
}
.topRect{
  position: absolute;
  left: 2px;
  right: 2px;
  top: 2px;
  bottom: 2px;
  background: #FF4F26;
  background: linear-gradient(135deg, transparent 0.25em, #FF4F26 0) top left,
  linear-gradient(-135deg, transparent 0.25em, #FF4F26 0) top right,
  linear-gradient(-45deg, transparent 0.25em, #FF4F26 0) bottom right,
  linear-gradient(45deg, transparent 0.25em, #FF4F26 0) bottom left;
  background-size: 51% 51%;
  background-repeat: no-repeat;

}
.topRect .cloud{
  position:absolute;
  width: 10vw;
}
.topRect .cloud img{
  width: 100%;
}
.topBar{
  margin: 1em 0.5em 0 0.5em;
  font-size: 0.7em;
  font-weight: 900;
}
.topBar img{
  height: 1.5em;
  text-align: center;
}
.myMoney{
  text-align:  center;
  font-size: 2.6em;
  font-weight: 900;
  color: #fff;
}
.myMoney span{
  font-size: 0.7em;
}

.progress{
  position: absolute;
  margin:  0.25em 0.5em;
  left: 0em;
  bottom: 0em;
}
.progress img{
  width: calc(100vw - 3em - 4px);
}
.progress .progressTop{
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
}
.giftList{
  text-align: center;
  margin: 1em 1em 0 1em;
}
.giftList .giftIcon{
  margin:0 0.15em;
  position: relative;
}
.giftList .giftIcon img{
  width: 100%;
}
.giftList .giftIcon .icon{
  position: absolute;
  left: 0;
  bottom: 0;
  margin: 5%;
}
.giftList .giftIcon .topBack{
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.giftList .giftName{
  font-size: 0.7em;
  word-break:break-all;
  font-weight: 700;
}
.giftList .giftPrice{
   font-weight: 700;
   font-size: 1.1em;
   color: #fff;
   line-height: 2em;
}
.giftList .giftPrice span{
  font-size: 0.6em;
}
.giftList .giftButton{
  padding:0 0.15em;
}
.giftList .giftButton img{
  width: 100%;
}
.baseRect{
  background-color: #4140FE;
  padding-top: 0.5em;
  border-top: 2px solid #000;
}
.baseRect .titleRect{
    margin: 1em;
    background-image: url(/grouptest/score/line1.png);
    background-size:auto 1.5em;
    height: 1.5em;
    text-align: center;
    line-height: 1.5em;
    position: relative;
}
.baseRect .titleRect .titleBody{
    background-color: #4140FE;
    color: #fff;
     font-size: 1.2em;
     padding: 0.5em 0.5em;
     font-weight: 700;
}
.listRect{
  margin: 1em 3em;
}
.listRect .lineRect{
  line-height: 2em;
  font-weight: 700;
  font-size:0.9em;
  padding: 0.1em 0;
  color: #fff;
}

.emptyRect{
    height: 4em;
}
.downButtonRect{
    position: fixed;
    padding: 0 1em;
    left: 0;
    right: 0;
    bottom: 0;
    height: 3em;
    padding-top: 1em;
    background-color: #F9AE3E;
}

.posterPage{
  height: 100vh;
  width: 100vw;
  background-color: #527EFE;
  text-align: center;
}
.posterPage .backButton{
   text-align: left;
   color: #fff;
   padding: 0.5em;
}
.posterPage .posterImg {
  width: 76vw;
  margin-bottom: 0.5em;
  box-shadow: 5px 5px 10px rgba(0,0,0,0.1)
}
.posterPage .shareAbout{
  font-size: 0.7em;
  color: #fff;
  text-align: center;
  margin-top: 0.5em;
}
</style>
